import { useEffect } from 'react';
import { PREFETCH_FALLBACK_DELAY_MS } from '@constants/timing';

type Loader = () => Promise<unknown>;
/** Runs `fn` when the browser is idle; returns the cancel. requestIdleCallback is missing in Safari: short delay. */
function idle(fn: () => void): () => void {
  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(fn);
    return () => window.cancelIdleCallback(id);
  }
  const t = window.setTimeout(fn, PREFETCH_FALLBACK_DELAY_MS);
  return () => window.clearTimeout(t);
}

/** Data saver or a 2G connection: only load what is opened. */
const saveData = () => {
  const c = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
  return !!c?.saveData || /2g/.test(c?.effectiveType ?? '');
};

/** Once the browser is idle, fetch the chunks of the pages this area links to (navigation stays instant). */
export function IdlePrefetch({ loaders }: { loaders: Loader[] }) {
  useEffect(() => {
    if (saveData()) return;
    return idle(() => loaders.forEach((l) => void l().catch(() => undefined)));
  }, [loaders]);
  return null;
}
